<form novalidate>
  <div class="row flex-row align-items-end">
    @if (canFilterByClients) {
      <div class="col">
        <div class="my-0 py-0">
          <label for="clientIds">Clients</label>
          <app-client-select
            name="clientIds"
            placeholder="Filter by Client"
            [multiple]="true"
            [autoLoad]="true"
            [listFilters]="{ applicableToReferralClaims: true }"
            [(selectedIds)]="filters.selectedClientIds"
            (changed)="onFilterChange()"
          />
        </div>
      </div>
    }
    <div class="col">
      <div class="my-0 py-0">
        <label for="patientFirstName">Patient First Name</label>
        <input
          id="patientFirstName"
          class="form-control"
          name="patientFirstName"
          placeholder="Filter By First Name"
          [(ngModel)]="filters.patientFirstName"
          (input)="onTextFilterChange()">
      </div>
    </div>
    <div class="col">
      <div class="my-0 py-0">
        <label for="patientLastName">Patient Last Name</label>
        <input
          id="patientLastName"
          class="form-control"
          name="patientLastName"
          placeholder="Filter By Last Name"
          [(ngModel)]="filters.patientLastName"
          (input)="onTextFilterChange()">
      </div>
    </div>
    <div class="col">
      <div class="my-0 py-0">
        <label for="patientDob">Patient DOB</label>
        <input
          id="patientDob"
          class="form-control"
          type="date"
          name="patientDob"
          [(ngModel)]="filters.patientDob"
          (change)="onFilterChange()"
          >
      </div>
    </div>
    <div class="col">
      <button class="btn btn-info" (click)="onClearClick()">Clear All</button>
    </div>
  </div>
</form>
@if (showTable) {
  <div class="mt-2">
    <table class="table table-bordered table-hover">
      <thead class="table-dark">
        <tr>
          <th>PATIENT</th>
          @if (canFilterByClients) {
            <th>CLIENT</th>
          }
          <th>DOB</th>
          <th>MRN</th>
          <th>DOCUMENT</th>
          <th></th>
          <th>SENT AT</th>
        </tr>
      </thead>
      <tbody>
        @for (patientAttachment of patientAttachments; track patientAttachment) {
          <tr>
            <td class="phi">{{ patientAttachment.patient.fullName }}</td>
            @if (canFilterByClients) {
              <td>{{ patientAttachment.client.name }}</td>
            }
            <td class="phi">{{ patientAttachment.patient.dob | date: 'MM/dd/yyyy' }}</td>
            <td class="phi">{{ patientAttachment.patient.mrn }}</td>
            <td class="phi">{{ patientAttachment.fileName | blankValueDash }}</td>
            <td>
              @if (patientAttachment.fileName) {
                <a href="/download" (click)="download($event, patientAttachment)">
                  Download
                </a>
              }
              @if (patientAttachment.pdfGenerationPending) {
                <span>
                  Preparing
                </span>
              }
            </td>
            <td>
              <div>
                {{ patientAttachment.directMessageSentAt | date: 'MM/dd/yyyy' }} to
                <div>{{ patientAttachment.directMessageSentTo }}</div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
  </div>
}

@if (noResults) {
  <div class="mt-2 ms-1">There are no consult notes.</div>
}

@if (loading) {
  <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
}
